import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "fixed z-[999] w-full bottom-0 left-0 right-0 border border-greyScale100 bg-greyScale50 pt-2 md:pt-6 md:pb-4 rounded-t-xl" }
const _hoisted_2 = { class: "Container flex flex-col-reverse md:flex-row items-center justify-between" }
const _hoisted_3 = { class: "hidden md:block" }
const _hoisted_4 = { class: "hidden md:block h4 !font-semibold" }
const _hoisted_5 = { class: "w-full md:max-w-[360px]" }
const _hoisted_6 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2" }
const _hoisted_9 = {
  key: 0,
  class: "animate-spin h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center justify-center gap-x-6 lg:gap-x-4 pb-1 pt-[2px]" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center text-secondary text-[12px] font-semibold leading-6" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "w-[16px] h-[16px] rounded-full flex items-center justify-center bg-secondary/20 mr-1" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        width: "18px",
        height: "20px",
        viewBox: "0 0 18 20",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }, [
        /*#__PURE__*/_createElementVNode("title", null, "security"),
        /*#__PURE__*/_createElementVNode("g", {
          id: "Page-1",
          stroke: "none",
          "stroke-width": "1",
          fill: "none",
          "fill-rule": "evenodd"
        }, [
          /*#__PURE__*/_createElementVNode("g", {
            id: "1-Home",
            transform: "translate(-315, -522)",
            "fill-rule": "nonzero"
          }, [
            /*#__PURE__*/_createElementVNode("g", {
              id: "hero",
              transform: "translate(304, 24)"
            }, [
              /*#__PURE__*/_createElementVNode("g", {
                id: "Text",
                transform: "translate(0, 200)"
              }, [
                /*#__PURE__*/_createElementVNode("g", {
                  id: "features",
                  transform: "translate(0, 288)"
                }, [
                  /*#__PURE__*/_createElementVNode("g", {
                    id: "security",
                    transform: "translate(11, 10)"
                  }, [
                    /*#__PURE__*/_createElementVNode("path", {
                      d: "M17.1251373,11.139941 L17.1251373,4.36124122 C17.1203073,3.39704065 16.5465778,2.52665091 15.6623642,2.14210898 L12.7546588,0.871994701 C10.0796131,-0.2906649 7.04195541,-0.2906649 4.36690975,0.871994701 L1.46277206,2.14210898 C0.57619407,2.52769116 0.00200234535,3.40158295 0,4.36837669 L0,11.1470765 C0.000264000298,13.1642426 0.954056656,15.0625677 2.57233818,16.2667787 L6.81080941,19.4206579 C7.84959569,20.193114 9.27197286,20.193114 10.3107591,19.4206579 L14.5492304,16.2667787 C16.170874,15.0618205 17.1262905,13.1602506 17.1251373,11.139941 Z",
                      id: "Path",
                      fill: "#77B860"
                    }),
                    /*#__PURE__*/_createElementVNode("path", {
                      d: "M12.7110919,7.28890812 C13.0963027,7.67411895 13.0963027,8.2986691 12.7110919,8.68387993 L8.94624607,12.4487257 C8.67196782,12.7233281 8.31201175,12.8926635 7.92915602,12.9307067 L7.76385599,12.9388968 C7.32029335,12.9388968 6.89492678,12.762557 6.58160773,12.4488676 L5.28890812,11.1561679 C4.90369729,10.7709571 4.90369729,10.146407 5.28890812,9.76119613 C5.67411895,9.3759853 6.2986691,9.3759853 6.68387993,9.76119613 L7.76163731,10.8429672 L11.3161201,7.28890812 C11.7013309,6.90369729 12.3258811,6.90369729 12.7110919,7.28890812 Z",
                      id: "Path",
                      fill: "#FFFFFF"
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-secondary text-[12px]" }, "Bezpieczne płatności")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center text-secondary text-[12px] font-semibold leading-6" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "w-[16px] h-[16px] rounded-full flex items-center justify-center bg-secondary/20 mr-1" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        width: "20px",
        height: "20px",
        viewBox: "0 0 20 20",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }, [
        /*#__PURE__*/_createElementVNode("title", null, "check"),
        /*#__PURE__*/_createElementVNode("g", {
          id: "Page-1",
          stroke: "none",
          "stroke-width": "1",
          fill: "none",
          "fill-rule": "evenodd"
        }, [
          /*#__PURE__*/_createElementVNode("g", {
            id: "1-Home",
            transform: "translate(-535, -522)"
          }, [
            /*#__PURE__*/_createElementVNode("g", {
              id: "hero",
              transform: "translate(304, 24)"
            }, [
              /*#__PURE__*/_createElementVNode("g", {
                id: "Text",
                transform: "translate(0, 200)"
              }, [
                /*#__PURE__*/_createElementVNode("g", {
                  id: "features",
                  transform: "translate(0, 288)"
                }, [
                  /*#__PURE__*/_createElementVNode("g", {
                    id: "icon-text",
                    transform: "translate(221, 0)"
                  }, [
                    /*#__PURE__*/_createElementVNode("g", {
                      id: "check",
                      transform: "translate(10, 10)"
                    }, [
                      /*#__PURE__*/_createElementVNode("circle", {
                        id: "Oval",
                        fill: "#77B860",
                        cx: "10",
                        cy: "10",
                        r: "10"
                      }),
                      /*#__PURE__*/_createElementVNode("path", {
                        d: "M13.7110919,7.28890812 C14.0963027,7.67411895 14.0963027,8.2986691 13.7110919,8.68387993 L9.94624607,12.4487257 C9.67196782,12.7233281 9.31201175,12.8926635 8.92915602,12.9307067 L8.76385599,12.9388968 C8.32029335,12.9388968 7.89492678,12.762557 7.58160773,12.4488676 L6.28890812,11.1561679 C5.90369729,10.7709571 5.90369729,10.146407 6.28890812,9.76119613 C6.67411895,9.3759853 7.2986691,9.3759853 7.68387993,9.76119613 L8.76163731,10.8429672 L12.3161201,7.28890812 C12.7013309,6.90369729 13.3258811,6.90369729 13.7110919,7.28890812 Z",
                        id: "Path",
                        fill: "#FFFFFF",
                        "fill-rule": "nonzero"
                      })
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-secondary text-[12px]" }, "Szybka realizacja")
  ])
], -1)


export default {
  __name: 'AddToCartButton',
  props: {
    price: {
        type: String,
        required: true,
    },
    isSubmitting: {
        type: Boolean,
        required: true,
    },
    title: {
        type: String,
        required: true,
    },
},
  setup(__props) {

const props = __props;



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(__props.title), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: _normalizeClass(["Button w-full md:max-w-[400px] py-4 relative", {
                        'is-submitting': __props.isSubmitting,
                    }])
        }, [
          (!__props.isSubmitting)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createTextVNode(" Zamawiam za "),
                _createElementVNode("span", {
                  class: "flex items-center justify-center",
                  innerHTML: __props.price
                }, null, 8, _hoisted_7)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_8, [
            (__props.isSubmitting)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_12))
              : _createCommentVNode("", true)
          ])
        ], 2),
        _hoisted_13
      ])
    ])
  ]))
}
}

}